module.exports = __webpack_public_path__ + "static/Apercu-Mono-5caa1465e4df2deaa462254e0a760254.otf";